export default __webpack_public_path__ + "static/media/4646.33ff3ca9.png";